
















  import Vue from 'vue';

  export default Vue.extend({
    name: 'Alerte',
    props: {
      noMargin: {
        type: Boolean,
        default: false,
      },
      afficher: {
        type: Boolean,
        default: true,
      },
      message: {
        type: String,
        required: true,
      },
      type: {
        type: String,
        default: 'warning',
      },
    },
  });
